import {
  ICDLOOKUP_REQUEST,
  ICDLOOKUP_SUCCESS,
  ICDLOOKUP_FAILURE,
  ICD_REQUEST,
  ICD_SUCCESS,
  ICD_FAILURE,
  ICD_UPDATE_REQUEST,
  ICD_UPDATE_SUCCESS,
  ICD_UPDATE_FAILURE,
} from './IcdLookupActions'

const initialState = {
  data: [],
  icd: {},
  error: null,
  isLoading: false,
};

export default function icdLookupReducer(
  state = initialState,
  { type, payload },
) {
  switch (type) {
    case ICDLOOKUP_REQUEST:
      return { ...state, isLoading: true };
    case ICDLOOKUP_SUCCESS:
      return { ...state, data: payload.data, icd: {}, error: null, isLoading: false };
    case ICDLOOKUP_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case ICD_REQUEST:
      return { ...state, isLoading: true };
    case ICD_SUCCESS:
      return { ...state, icd: payload.data, errors: null, isLoading: false };
    case ICD_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case ICD_UPDATE_REQUEST:
      return { ...state, isLoading: true };
    case ICD_UPDATE_SUCCESS:
      return { ...state, icd: payload.data, errors: null, isLoading: false };
    case ICD_UPDATE_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/icd-lookup/IcdLookupReducer.js